import type { Module } from "@/types/modules";
import { AutomationsSurface } from "./AutomationsSurface";
import "../_infrastructure/ModuleStyles.css";
import "./AutomationsModule.css";
// Retained `autoui-*` styles still used by cross-module consumers (chat ScopeChip, sidebar-rail
// notification badge). The four-card surface ships its own automations-surface.css.
import "./redesign/automations-redesign.css";

/**
 * Automations module — four fixed, non-deletable automations (Email Auto-Draft Responder, Daily
 * Brief, Overnight Processing, Meeting Prep). Each card has a one-line description, an on/off toggle
 * wired to PATCH /sub-agents/:id/config, a "last run" line that deep-links into the Activity Center,
 * and a Customize panel. See docs/design/2026-06-26-automations-module-revamp-design.md.
 */
export default function AutomationsModule({
  module,
  conversationId: _conversationId,
}: {
  module: Module;
  conversationId: string;
}) {
  return (
    <div className="module automations-module">
      <div className="module-content xv-scroll">
        <AutomationsSurface moduleId={module.id} />
      </div>
    </div>
  );
}
